import { render, staticRenderFns } from "./sangle.vue?vue&type=template&id=45366776&scoped=true"
import script from "./sangle.vue?vue&type=script&lang=js"
export * from "./sangle.vue?vue&type=script&lang=js"
import style0 from "./sangle.vue?vue&type=style&index=0&id=45366776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45366776",
  null
  
)

export default component.exports